export const routesMapping = {
    "/dashboard": {
        label: "پیشخوان",
        queries: [],
        getPath: () => `/dashboard`,
    },
    "/courses": {
        label: "دوره و جلسات",
        queries: [],
        getPath: () => `/courses`,
    },
    "/profile": {
        label: "پروفایل",
        queries: [],
        getPath: () => `/profile`,
    },
    "/settings": {
        label: "تنظیمات",
        queries: [],
        getPath: () => `/settings`,
    },
    "/reports": {
        label: "کارنامه",
        queries: [],
        getPath: () => `/reports`,
    },
    "/about": {
        label: "درباره ما",
        queries: [],
        getPath: () => `/about`,
    },
    "/financial/credit": {
        label: "افزایش اعتبار",
        queries: [],
        getPath: () => `/financial/credit`,
    },
    "/financial/donate": {
        label: "کمک مالی",
        queries: [],
        getPath: () => `/financial/donate`,
    },
    "/financial/transactions": {
        label: "تراکنش‌ ها",
        queries: [],
        getPath: () => `/financial/transactions`,
    },
    "/questions/common": {
        label: "پرسش و پاسخ های متداول",
        queries: [],
        getPath: () => `/questions/common`,
    },
    "/questions/mine": {
        label: "سوال های من",
        queries: [],
        getPath: () => `/questions/mine`,
    },
};
